/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Wb_Operations_Val_DeliveryInputs */

const en_wb_operations_val_delivery = /** @type {(inputs: Wb_Operations_Val_DeliveryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Friday, 18 September`)
};

const lv_wb_operations_val_delivery = /** @type {(inputs: Wb_Operations_Val_DeliveryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Piektdien, 18. septembrī`)
};

/**
* | output |
* | --- |
* | "Friday, 18 September" |
*
* @param {Wb_Operations_Val_DeliveryInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const wb_operations_val_delivery = /** @type {((inputs?: Wb_Operations_Val_DeliveryInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wb_Operations_Val_DeliveryInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_wb_operations_val_delivery(inputs)
	return en_wb_operations_val_delivery(inputs)
});